<h2 class="default-dialog-header font-weight-normal" mat-dialog-title>
	<span fxFlex>{{ title }}</span>
</h2>
<mat-divider></mat-divider>

<form (keydown.enter)="$event.preventDefault()" [formGroup]="rateDetails">
	<mat-dialog-content class="default-dialog-content">
		<div
			*ngIf="!hasRate"
			class="p-8"
			fxLayout="row"
			fxLayoutAlign="center center"
			fxLayoutGap="1rem"
		>
			<a (click)="closeDialog(null)"
				><span class="primary-text text-underline cursor-pointer">No</span></a
			>
			<button (click)="hasRate = true" color="primary" mat-raised-button>Yes</button>
		</div>

		<div *ngIf="hasRate">
			<div class="p-8 p-b-0" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="1rem">
				<div fxFlex>
					<mat-form-field class="full-width">
						<mat-icon class="primary-light-color vertical-align-bottom" matPrefix
							>attach_money
						</mat-icon>
						<input
							autocomplete="off"
							formControlName="desiredPrice"
							mask="separator"
							thousandSeparator=","
							prefix="$"
							matInput
							placeholder="{{ rateInputLabel }}"
						/>
					</mat-form-field>
				</div>

				<div *ngIf="isCarrierProvidingRate" fxFlex>
					<mat-form-field class="full-width">
						<input
							(click)="picker2.open()"
							[formControl]="expirationDate"
							[matDatepicker]="picker2"
							[min]="minExpirationDate"
							autocomplete="off"
							matInput
							placeholder="Expiration date"
						/>
						<mat-datepicker-toggle [for]="picker2" matSuffix tabIndex="-1"></mat-datepicker-toggle>
						<mat-datepicker #picker2></mat-datepicker>
					</mat-form-field>
				</div>
			</div>

			<div *ngIf="!isCarrierProvidingRate" class="p-8" fxLayout="row" fxLayoutAlign="center center">
				<mat-form-field class="full-width">
					<input
						(click)="picker1.open()"
						[formControl]="carrierRespondedAt"
						[matDatepicker]="picker1"
						matInput
						placeholder="Rate Received"
					/>
					<mat-datepicker-toggle [for]="picker1" matSuffix tabIndex="-1"></mat-datepicker-toggle>
					<mat-datepicker #picker1></mat-datepicker>
				</mat-form-field>
			</div>

			<div *ngIf="isCarrierProvidingRate">
				<form (keydown.enter)="$event.preventDefault()" [formGroup]="carrierRateDetails">
					<div class="p-8" fxLayout="row" fxLayoutGap="1rem">
						<div fxFlex>
							<mat-form-field fxFlex="100">
								<mat-label>Loads Per Week Duration</mat-label>
								<input
									autocomplete="off"
									formControlName="loadVolume"
									mask="separator"
									thousandSeparator=","
									matInput
								/>
							</mat-form-field>
						</div>

						<div fxFlex fxLayoutAlign="center center">
							<h4
								(click)="setSpecifyDays()"
								*ngIf="!specifyDays"
								class="primary-text font-weight-normal cursor-pointer"
								fxLayoutAlign="center start"
							>
								Specify Days
								<mat-icon class="primary-light-color mt-2">expand_more</mat-icon>
							</h4>
							<h4
								(click)="setSpecifyDays()"
								*ngIf="specifyDays"
								class="primary-text font-weight-normal cursor-pointer"
								fxLayoutAlign="center start"
							>
								Days Run
								<mat-icon class="primary-light-color m-r-1 mt-2">expand_less</mat-icon>
							</h4>
						</div>
					</div>

					<div *ngIf="specifyDays" class="p-8">
						<div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="1rem">
							<mat-checkbox [color]="'primary'" [labelPosition]="'after'" formControlName="monday">
								Monday
							</mat-checkbox>
							<mat-checkbox [color]="'primary'" [labelPosition]="'after'" formControlName="tuesday">
								Tuesday
							</mat-checkbox>
							<mat-checkbox
								[color]="'primary'"
								[labelPosition]="'after'"
								formControlName="wednesday"
							>
								Wednesday
							</mat-checkbox>
							<mat-checkbox
								[color]="'primary'"
								[labelPosition]="'after'"
								formControlName="thursday"
							>
								Thursday
							</mat-checkbox>
							<mat-checkbox [color]="'primary'" [labelPosition]="'after'" formControlName="friday">
								Friday
							</mat-checkbox>
							<mat-checkbox
								[color]="'primary'"
								[labelPosition]="'after'"
								formControlName="saturday"
							>
								Saturday
							</mat-checkbox>
							<mat-checkbox [color]="'primary'" [labelPosition]="'after'" formControlName="sunday">
								Sunday
							</mat-checkbox>
						</div>
					</div>
				</form>
			</div>
		</div>
	</mat-dialog-content>
	<mat-divider></mat-divider>

	<mat-dialog-actions *ngIf="hasRate" class="default-dialog-action">
		<div fxFlex="100" fxLayoutAlign="end center" fxLayoutGap="1rem">
			<a (click)="closeDialog(null)"
				><span class="primary-text text-underline cursor-pointer">Cancel</span></a
			>
			<button
				(click)="addRate()"
				[disabled]="rateDetails.invalid"
				color="primary"
				mat-raised-button
			>
				{{ submitButtonLabel }}
			</button>
		</div>
	</mat-dialog-actions>
</form>
